export default [
  {
    title: 'Inscreva-se',
    description:
      'Para se inscrever, basta ficar de olho nas campanhas que adicionamos todas sextas-feiras e clicar em “Inscreva-se”.',
    image:
      'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_18801.png',
  },
  {
    title: 'Aguarde a aprovação',
    description:
      'Caso você seja selecionada, será informado o status da sua participação aqui em campanhas. Caso não tenha sido aprovada, não desista! Queremos que todas participem 💖',
    image:
      'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_18796.png',
  },
  {
    title: 'Receba o produto',
    description:
      'Após a confirmação da sua participação, vamos liberar o briefing da postagem e o produto estará a caminho da sua casa.',
    image:
      'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_18795.png',
  },
  {
    title: 'Divulgue nas redes sociais',
    description:
      'Nessa etapa é importante ficar atento aos prazos, divulgar dentro do período estipulado no convite e seguir à risca as orientações do briefing.',
    image:
      'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_18800.png',
  },
  {
    title: 'Envie os comprovantes',
    description:
      '24h após a publicação ou assim que as métricas estiverem completas, nos envie prints de tela mostrando TODAS métricas disponibilizadas pelo story. Para enviar, basta clicar em “Enviar comprovante” na campanha selecionada.',
    image:
      'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_18799.png',
  },
  {
    title: 'Receba o pagamento',
    description:
      'O pagamento da campanha será programado para o dia 10 do mês seguinte (ou o próximo dia útil).',
    image:
      'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_18798.png',
  },
];
